module.exports = __webpack_public_path__ + "static/nin9logosquaredrk-c86f3baf0a3c1dc957edd72157034df6.png";